import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  overviewList: [],
  page: 1,
  loaded: false,
};

export const feedSlice = createSlice({
  name: "feeds",
  initialState,
  reducers: {
    setFeedPage: (state, action) => {
      state.page = action.payload || initialState.page;
    },
    setOverviewList: (state, action) => {
      state.overviewList = action.payload || initialState.overviewList;
      state.loaded = true;
    },
  },
});

export const { setFeedPage, setOverviewList } = feedSlice.actions;

export default feedSlice.reducer;
